import {
  Check,
  CheckCircle,
  Envelope,
  FacebookLogo,
  InstagramLogo,
  LinkedinLogo,
  Phone,
  PushPinSimple,
  WarningCircle,
} from '@phosphor-icons/react'
import React, { useState } from 'react'
import ContactBackground from '../../assets/images/Contact/ContactImage.svg'
import PrevixLogo from '../../assets/images/Contact/PrevixLogoHorizontalDescription.svg'
import { BackButton } from '../../components/BackButton'
import { Modal } from '../../components/Modal'
import { Button } from '../../components/common/Button'
import { Input } from '../../components/common/Input'
import api from '../../services/api'
import {
  Body,
  CheckboxAppearence,
  CheckboxInput,
  CheckboxLabel,
  Container,
  FooterContainer,
  FooterInfos,
  FooterLine,
  FooterMap,
  FooterMapCanva,
  FooterSection,
  FooterSocialMediaIcon,
  FooterTitle,
  Form,
  FormButtonContainer,
  FormCheckboxContainer,
  FormContainer,
  FormRow,
  FormTextArea,
  FormTitle,
  Header,
  ImageBackground,
  LogoContainer,
} from './styles'

interface ContactInfoProps {
  email: string
  name: string
  contact_number: string
  wpp_first_contact: boolean
  observations: string
}

export const Contact = () => {
  const [contactInfos, setContactInfos] = useState<ContactInfoProps>({
    email: '',
    name: '',
    contact_number: '',
    wpp_first_contact: true,
    observations: '',
  })

  const [checked, setChecked] = useState(contactInfos.wpp_first_contact)

  const [modalMessageSentSuccess, setModalMessageSentSuccess] = useState(false)
  const [modalMessageSentError, setModalMessageSentError] = useState(false)

  function handleCheckbox() {
    setChecked((prev) => {
      setContactInfos((current) => ({
        ...current,
        wpp_first_contact: !prev,
      }))
      return !prev
    })
  }

  const toggleFunction = (setValue) => {
    setValue((prev) => !prev)
  }

  const handleFormChange = (e) => {
    setContactInfos((current) => ({
      ...current,
      [e.target.name]: e.target.value,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const requiredFields = ['name', 'email', 'contact_number', 'observations']
    const missingFields = requiredFields.filter((field) => !contactInfos[field])

    if (missingFields.length > 0) {
      alert(`Por favor, preencha todos os campos obrigatórios`)
      return
    }

    api
      .post('/v1/contact/create', contactInfos)
      .then((response) => {
        console.log(response)
        toggleFunction(setModalMessageSentSuccess)
      })
      .catch((error) => {
        console.log(error.response)
        toggleFunction(setModalMessageSentError)
      })
  }

  return (
    <Container>
      <Header>
        <LogoContainer>
          <img src={PrevixLogo} alt="Previx logo" />
        </LogoContainer>
      </Header>
      <Body>
        <ImageBackground src={ContactBackground} />
        <FormContainer>
          <BackButton goTo={''} />
          <FormTitle>
            Preencha o formulário e aguarde um de nossos consultores lhe
            atender:
          </FormTitle>
          <Form>
            <Input.Root>
              <Input.Label
                title="Insira seu nome aqui"
                htmlFor="contactFormName"
              />
              <Input.Wrapper>
                <Input.Content
                  id="contactFormName"
                  placeholder="Nome"
                  name="name"
                  onChange={handleFormChange}
                  required
                />
              </Input.Wrapper>
            </Input.Root>
            <FormRow>
              <Input.Root>
                <Input.Label
                  title="Insira seu número para contato"
                  htmlFor="contactFormNumber"
                />
                <Input.Wrapper>
                  <Input.Content
                    type="tel"
                    id="contactFormNumber"
                    placeholder="(xx) xxxx-xxxx"
                    mask="telNumber"
                    pattern="(\(\d{2}\)\s?\d{5}-\d{4})"
                    name="contact_number"
                    onChange={handleFormChange}
                    required
                  />
                </Input.Wrapper>
              </Input.Root>
              <FormCheckboxContainer onClick={handleCheckbox}>
                <CheckboxInput checked={checked} onChange={handleCheckbox} />
                <CheckboxAppearence isChecked={checked}>
                  <Check size={36} />
                </CheckboxAppearence>
                <CheckboxLabel>
                  Desejo receber o primeiro contato pelo WhatsApp
                </CheckboxLabel>
              </FormCheckboxContainer>
            </FormRow>
            <Input.Root>
              <Input.Label
                title="Informe seu e-mail"
                htmlFor="contactFormEmail"
              />
              <Input.Wrapper>
                <Input.Content
                  id="contactFormEmail"
                  placeholder="E-mail"
                  type="email"
                  name="email"
                  onChange={handleFormChange}
                  required
                />
              </Input.Wrapper>
            </Input.Root>
            <Input.Root>
              <Input.Label
                title="Adicione suas observações"
                htmlFor="contactFormObservation"
              />
              <Input.Wrapper>
                <FormTextArea name="observations" onChange={handleFormChange} />
              </Input.Wrapper>
            </Input.Root>
            <FormButtonContainer>
              <Button.Root
                type="submit"
                backgroundColor="#150D49"
                onClick={handleSubmit}
              >
                <Button.Content title="Enviar para entrar em contato" />
              </Button.Root>
            </FormButtonContainer>
          </Form>
        </FormContainer>
      </Body>
      <FooterContainer>
        <FooterSection>
          <FooterTitle>MAIS INFORMAÇÕES</FooterTitle>
          <FooterInfos>
            <FooterLine>
              <PushPinSimple size={12} weight="fill" />
              <p>Av. Queiroz Filho, 917 - Vila Hamburguesa - São Paulo - SP</p>
            </FooterLine>
            <FooterLine>
              <Phone size={12} weight="fill" />
              <p>(11) 3875-1148</p>
            </FooterLine>
            <FooterLine>
              <Phone size={12} weight="fill" />
              <p>0800 515 0000 (SAC 24 Horas)</p>
            </FooterLine>
            <FooterLine>
              <Envelope size={12} />
              <p>previx@grupoprevix.com.br</p>
            </FooterLine>
          </FooterInfos>
          <FooterTitle>REDES SOCIAIS</FooterTitle>
          <FooterLine>
            <FooterSocialMediaIcon>
              <FacebookLogo size={32} weight="fill" />
            </FooterSocialMediaIcon>
            <FooterSocialMediaIcon>
              <InstagramLogo size={32} />
            </FooterSocialMediaIcon>
            <FooterSocialMediaIcon>
              <LinkedinLogo size={32} weight="fill" />
            </FooterSocialMediaIcon>
          </FooterLine>
        </FooterSection>
        <FooterSection>
          <FooterTitle>ONDE ESTAMOS</FooterTitle>
          <FooterMap>
            <FooterMapCanva>
              <iframe
                width="600"
                height="165"
                id="gmap_canvas"
                src="https://maps.google.com/maps?q=Av.%20Queiroz%20Filho%2C%20917%20-%20Vila%20Hamburguesa%20-%20S%C3%A3o%20Paulo%20-%20SP&t=&z=13&ie=UTF8&iwloc=&output=embed"
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
              ></iframe>
              <a href="http://vin-odometer.info">vin-odometer.info</a>
              <a href="https://embedmaps.info">Embed Google Maps</a>
            </FooterMapCanva>
          </FooterMap>
        </FooterSection>
      </FooterContainer>

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="30%"
        height="fit-content"
        left="50%"
        top="50%"
        open={modalMessageSentSuccess}
        setIsOpenController={() => {
          toggleFunction(setModalMessageSentSuccess)
          window.location.href = '/login'
        }}
      >
        <Modal.Header
          onclick={() => setModalMessageSentSuccess((prev) => !prev)}
        />
        <Modal.Icon icon={<CheckCircle size={48} fill="#006598" />} />
        <Modal.Content
          value="Mensagem enviada com sucesso!"
          subvalue="Logo uma pessoa de nossa equipe entrará em contato contigo para responder suas questões"
        />
        <Modal.Footer>{}</Modal.Footer>
      </Modal.Root>

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="30%"
        height="fit-content"
        left="50%"
        top="50%"
        open={modalMessageSentError}
        setIsOpenController={() => {
          toggleFunction(setModalMessageSentError)
        }}
      >
        <Modal.Header
          onclick={() => setModalMessageSentError((prev) => !prev)}
        />
        <Modal.Icon
          icon={<WarningCircle size={48} weight="fill" fill="#BB0000" />}
        />
        <Modal.Content
          value="Não conseguimos enviar seu atendimento"
          subvalue="Tente novamente mais tarde, pode ter ocorrido um erro de conexão, para mais detalhes, entre em contato conosco"
        />
        <Modal.Footer>{}</Modal.Footer>
      </Modal.Root>
    </Container>
  )
}
